import { CleanSearchEntity } from '@mais-retorno-front/core-business/domain/entities/clean-search.entity';
import { HTTP_STATUS_CODE, IHttpGet } from '../../adapters/http';
import { ComparisonError } from '../../errors';
import { IRequestDTO } from './dto';

export class SearchUseCase<T> {
  constructor(
    private readonly url: string,
    private readonly http: IHttpGet<T[]>
  ) {}

  async execute({ term }: IRequestDTO): Promise<T[]> {
    const { cleanTerm } = new CleanSearchEntity(term);

    if (cleanTerm.length < 2) {
      return [];
    }

    const { statusCode, body } = await this.http.get({
      url: `${this.url}/${cleanTerm}`,
    });

    if (statusCode === HTTP_STATUS_CODE.ok && body.length === 0) {
      throw new ComparisonError('Ativo não encontrado', 'NotFoundError');
    }

    switch (statusCode) {
      case HTTP_STATUS_CODE.ok:
        return body;

      default:
        throw new ComparisonError(
          'Algo de errado aconteceu. tente novamente em breve',
          'UnexpectedError'
        );
    }
  }
}
